__turbopack_context__.v({
  "portrait": "YouTubeEmbed-module-scss-module__BO3D2G__portrait",
  "videoWrapperClassName": "YouTubeEmbed-module-scss-module__BO3D2G__videoWrapperClassName",
  "youtubeContainer": "YouTubeEmbed-module-scss-module__BO3D2G__youtubeContainer",
});
